import { defineStore } from 'pinia';
import { getAsync, postAsync } from '../helpers/main';
import { useStore } from './main';
import { ResBaseDTO } from '../model/response.model';
import axios, { AxiosRequestConfig } from 'axios';
import moment from 'moment';
import { validateFileType, validateFileSize, errorItems, ErrorItem, SttResponse, SpeechToTextPayload, SpeechLanguage, defaultSpeechLanguage, speechLanguageList, FileValidation, UploadFileErrorType } from '../model/stt.model';
import { saveUserProfile } from '../helpers/saveLang';
// const baseUrl = 'http://stt.tonyvu.xyz:3001'
// const baseUrl = 'https://stt-dev.draiai.com'
// const baseUrl = 'http://54.241.210.58:3001'
const baseUrl = window.sttApiUrl

export const useSttStore = defineStore('Stt', {
    state: () => ({
        isFileUploadModal: false,

        loginToken: '',

        primaryLanguage: 'en-US',
        secondaryLanguage: 'en-US',

        sseEvent: {} as EventSource,
        sseEventUrl: '' as URL | string,

        // 狀態
        isCallingApi: false,
        isSttProcessing: false,
        isUploading: false,

        displayTextList: [] as string[],

        keyTime: 0,
        uploadProgress: 0,

        // reUpload: false,
        timeUpload: '',

        retryCount: 2,

        sttSpeechLanguage: '',

        isFileUploadProcessSuccess: false,
        isFileUploadProcessFail: false,
        isFileUploadSaving: false,

        hasUploadTempFile: false,
    }),

    getters: {
        authVerifyUrl(): string {
            // return `${baseUrl}/api/v1/auth/login`
            return `${baseUrl}/api/v1/auth/verify`
        },

        uploadFileUrl(): string {
            return `${baseUrl}/api/v1/speech-to-text/transcribe`
        },

        speechToTextUrl(): string {
            return `${baseUrl}/api/v1/speech-to-text/transShortAudio`
        },

        isLogin(): boolean {
            return !!this.loginToken
        },

        isRetry(): boolean {
            return this.retryCount < 2
        },

        getSttSpeechLanguage(): SpeechLanguage['value'] {
            const value = localStorage.getItem('speechLanguage') ?? defaultSpeechLanguage.value
            this.sttSpeechLanguage = value
            return this.sttSpeechLanguage
        }
    },

    actions: {
        switchFileUploadModal() {
            this.isFileUploadModal = !this.isFileUploadModal
        },
        closeFileUploadModal() {
            this.isFileUploadModal = false
        },

        setUploadProcessDefault() {
            this.isFileUploadProcessSuccess = false
            this.isFileUploadProcessFail = false
        },

        setSttSpeechLanguage(value: SpeechLanguage['value']) {
            localStorage.setItem('speechLanguage', value)
            this.sttSpeechLanguage = value;
            saveUserProfile();
        },

        // async getToken() {
        //     const payload = {
        //         "username": "sttbackend_user",
        //         "password": "$2b$10$E6VWxIzMEjYhjf7J8Q9l5OSG1ixJ3iC/rF0uV3iWq7.km09oTPKWW",
        //         "id": 1
        //     }
        //     const config = {
        //         headers: {
        //             "Content-Type": "application/json",
        //         },
        //     }

        //     try {
        //         const response = await axios.post(this.authLoginUrl, payload, config)
        //         // console.log("🚀 ~ checkLogin ~ response:", response)
        //         /**reponse.data
        //          * {
        //                 "statusCode": 200,
        //                 "message": "Login successful",
        //                 "data": {
        //                     "access_token": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6InN0dGJhY2tlbmRfdXNlciIsInN1YiI6MSwiaWF0IjoxNzIzMTAzMzg4fQ.SjEI_3uxVKrwo9NrBWK-SOB7YR0UTqfufcWKVaC3vRw"
        //                 }
        //             }
        //          */
        //         if (response.data.statusCode === 200) {
        //             const token = response.data.data.access_token
        //             // localStorage.setItem("sttToken", token)
        //             this.loginToken = token
        //             this.sseEventUrl = new URL(`${baseUrl}/api/v1/events/stream`)
        //             this.sseEventUrl.searchParams.append('token', this.loginToken)
        //         } else {
        //             this.loginToken = ''
        //             console.log('Please reload page to get access token.')
        //             // alert("Please reload page to get access token.");
        //         }

        //     } catch (error) {
        //         console.error(error)
        //     }
        // },

        async getToken() {
            // const payload = {
            //     "username": "sttbackend_user",
            //     "password": "$2b$10$E6VWxIzMEjYhjf7J8Q9l5OSG1ixJ3iC/rF0uV3iWq7.km09oTPKWW",
            //     "id": 1
            // }
            // const config = {
            //     headers: {
            //         "Content-Type": "application/json",
            //     },
            // }

            try {
                const token = localStorage.getItem('token')
                const url = `${this.authVerifyUrl}?token=${token}`
                const response = await axios.get(url)
                // console.log("🚀 ~ checkLogin ~ response:", response)
                /**reponse.data
                 * {
                        "statusCode": 200,
                        "message": "Verify successful",
                        "data": {
                            "uuid": "0CCD0245-6504-47BE-8BE7-06739BDDB112",
                            "email": "toby811023@gmail.com",
                            "appUserId": "64",
                            "message": "Successfully refresh token!!",
                            "token": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6InRvYnk4MTEwMjNAZ21haWwuY29tIiwidXNlcl9pZCI6IjBDQ0QwMjQ1LTY1MDQtNDdCRS04QkU3LTA2NzM5QkREQjExMiIsInN1YiI6IjY0IiwiaWF0IjoxNzIzNzcwNDQzfQ.clpUceEuZRFigvx1K88WqpW1AY9ZglLxOvVZ2jH-1Po"
                        }
                    }
                 */
                if (response.data.statusCode === 200) {
                    const token = response.data.data.token
                    // localStorage.setItem("sttToken", token)
                    this.loginToken = token
                    this.sseEventUrl = new URL(`${baseUrl}/api/v1/events/stream`)
                    this.sseEventUrl.searchParams.append('token', this.loginToken)
                    this.sseEventUrl.searchParams.append("application", "pro");
                } else {
                    this.loginToken = ''
                    console.error('Please reload page to get access token.')
                    // alert("Please reload page to get access token.");
                }

            } catch (error) {
                console.error(error)
            }
        },

        uploadCheck(file: File, onError: Function) {
            const audio = new Audio();
            audio.preload = "metadata";
            let errorType: UploadFileErrorType

            const isValidateFileType = validateFileType(file)
            const isValidateFileSize = validateFileSize(file)

            if (!isValidateFileType) {
                errorType = 'fileTypeError'
                onError(errorType)
                return false;
            }

            if (!isValidateFileSize) {
                errorType = 'fileSizeError'
                onError(errorType)
                return false;
            }

            if (isValidateFileType && isValidateFileSize) {
                return new Promise((resolve, reject) => {
                    audio.onloadedmetadata = () => {
                        const durationLimit = FileValidation.FILE_DURATION * 60 // 單位 second
                        if (audio.duration > durationLimit) {
                            errorType = 'fileDurationError'
                            onError(errorType)
                            reject(false);
                        } else {
                            resolve(true);
                        }
                        URL.revokeObjectURL(audio.src);
                    };
                    // audio.onerror = () => {
                    //     console.log("🚀  ~ onloadedmetadata:yes-3")
                    //     alert(`${ERRORS.PRO_MS_UPLOAD_MSG_FILE_DURATION_LIMIT}`);
                    //     reject(false);
                    // };
                    audio.src = URL.createObjectURL(file);
                });
            }

            return true;
        },

        async uploadFile(options: {
            file: File;
            onSuccess: Function;
            onError: Function;
            primaryLanguage?: string;
            pageOpenFrom?: string;
        }) {
            const { file, onSuccess, onError, primaryLanguage, pageOpenFrom } = options;
            this.primaryLanguage = primaryLanguage || this.primaryLanguage
            this.isCallingApi = true;
            this.displayTextList = [];
            this.isUploading = true;
            this.isFileUploadProcessSuccess = false;
            this.isFileUploadProcessFail = false;

            const formData = new FormData();
            formData.append("file", file);
            formData.append("primaryLanguageCode", this.primaryLanguage);
            formData.append("secondaryLanguageCodes[]", this.secondaryLanguage);
            formData.append("application", "pro");
            formData.append("trans_type", "azure");
            const config: AxiosRequestConfig<FormData> = {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    "Authorization": `Bearer ${this.loginToken}`
                },
                timeout: 1800000,
                onUploadProgress: (progressEvent) => {
                    // console.log("🚀 ~ uploadFile ~ progressEvent:", progressEvent)
                    if (!!progressEvent.total) {
                        const percent = Math.floor(
                            (progressEvent.loaded * 100) / progressEvent.total
                        );
                        if (percent < 100) {
                            this.uploadProgress = percent;
                            // console.log("uploadProgress", this.uploadProgress);
                        }
                    }
                },
            }

            const response = await axios
                .post(this.uploadFileUrl, formData, config)
                .then((result) => {
                    // console.log("🚀 ~ .then ~ result:", result)
                    if (result.data.statusCode === 200) {
                        this.uploadProgress = 100;
                        // this.reUpload = false;
                        setTimeout(() => {
                            this.isUploading = false;
                            this.isSttProcessing = true;
                            this.uploadProgress = 0
                        }, 1000);
                        this.keyTime = result.data.data.keyTime;
                        this.timeUpload = moment().format("YYYY-MM-DD HH:mm:ss");

                        onSuccess({ isUploadFileOk: true, isSttProcessOK: false });

                        if (pageOpenFrom == 'medical-scribe') {
                            localStorage.setItem('sttData', JSON.stringify({ keyTime: this.keyTime }))
                        }

                        this.connectToServer(onSuccess, onError);
                    }
                })
                .catch((error) => {
                    // console.log("🚀 ~ uploadFile ~ error:", error)
                    if (this.retryCount > 0) {
                        this.retryCount--;

                        // recall api
                        setTimeout(() => {
                            return this.uploadFile({ file, onSuccess, onError });
                        }, 2000);
                    } else {
                        // this.uploadProgress = 99;
                        // this.reUpload = true;

                        if (!!error.response) {
                            const itemError = errorItems.find(
                                (el: ErrorItem) =>
                                    el.status === error.response?.data?.message ||
                                    el.codeErr === error.response?.data?.statusCode?.toString()
                            );
                            setTimeout(() => {
                                // alert(itemError?.message);
                                console.error(itemError);
                            }, 1000);
                        }

                        const isTimeOutError = error.code === "ECONNABORTED"
                        // if (error.code === "ECONNABORTED") {
                        //     alert(ERRORS?.REQUEST_TIME_OUT);
                        // } else {
                        //     alert('System is busy. Please try again later.');
                        // }

                        onError({ isTimeOutError });

                        setTimeout(() => {
                            this.retryCount = 2;
                            this.isUploading = false;
                            this.isCallingApi = false;
                            this.uploadProgress = 0;
                        }, 1000);

                    }
                });
        },

        connectToServer(onSuccess: Function, onError: Function) {
            this.sseEvent = new EventSource(this.sseEventUrl);

            this.sseEvent.onopen = () => {
                // console.log("Connection opened");
                this.isCallingApi = true;
            };

            this.sseEvent.onmessage = (event) => {
                // console.log("🚀 ~ connectToServer ~ event:", event)
                // const data = JSON.parse(event.data);
                // this.sttData = data?.message
                // const messageElement = document.createElement("div");
                // messageElement.textContent = data.message;
            };

            this.sseEvent.onerror = (error: any) => {
                onError({ isTimeOutError: false })
                // console.log("🚀 ~ connectToServer ~ error:", error)
                // alert("Some thing went wrong. Please try again");
                this.isCallingApi = false;
                // if (error.readyState !== undefined) {
                //     this.displayTextList = [];
                // }
            };

            this.sseEvent.addEventListener("message", (event) => {
                // console.log("🚀 ~ this.sseEvent.addEventListener ~ event:", event)
                const data = JSON.parse(event.data);
                // console.log("🚀 ~ this.sseEvent.addEventListener ~ data:", data)
                const item = JSON.parse(data.message)[this.keyTime]
                    ? JSON.parse(JSON.parse(data.message)[this.keyTime])
                    : null;
                // console.log("🚀 ~ this.sseEvent.addEventListener ~ item:", item)

                if (item && item.results && item.status === 3) {
                    const text: string[] = item.results;
                    // // console.log("🚀 ~ this.sseEvent.addEventListener ~ text:", text)

                    if (Array.isArray(text)) {
                        // showData.value = true;
                        this.displayTextList = [];
                        this.isSttProcessing = false;
                        text.forEach((element) => {
                            this.displayTextList.push(element);
                        });
                        onSuccess({ isUploadFileOk: true, isSttProcessOK: true })
                    }
                    this.stopCallApi();
                } else if (
                    item &&
                    item.results &&
                    item.status === 2 &&
                    Array.isArray(item.results)
                ) {
                    const itemErr = errorItems.find((item: any) =>
                        item.results.length > 0 ? item.code === item.status : null
                    );

                    alert(
                        itemErr
                            ? `Error: ${itemErr.codeErr} - ${itemErr.message} `
                            : errorItems.find((item: any) => item.code === 5)?.message
                    );
                    this.stopCallApi();
                } else if (item && item.error) {
                    const itemErr = errorItems.find(
                        (el: ErrorItem) =>
                            el.codeErr === item.error.code && el.status === item.error.status
                    );
                    alert(`Error: ${itemErr?.codeErr} - ${itemErr?.message} `);
                }
            });
        },

        stopCallApi() {
            if (!!this.sseEvent) {
                this.isCallingApi = false;
                this.sseEvent.close();
                this.isSttProcessing = false;
            }

            this.hasUploadTempFile = false;
            localStorage.removeItem('sttData');
        },

        async speechToText(data: SpeechToTextPayload) {
            let ret = new ResBaseDTO()
            const { time, order, base64Url, languageCode } = data
            const formData = new FormData();
            formData.append('time', time);
            formData.append('order', order);
            formData.append('content', base64Url);
            formData.append('languageCode', languageCode);

            const config: AxiosRequestConfig<FormData> = {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    "Authorization": `Bearer ${this.loginToken}`
                },
            }

            try {
                const response = await axios.post(this.speechToTextUrl, formData, config)
                // console.log("🚀 ~ speechToText ~ response:", response)
                /**response.data
                 * {
                        "time": "1723518210987",
                        "transcript": "對不起",
                        "languageCode": "cmn-hant-tw",
                        "order": "0"
                    }
                 */
                ret.result = true
                ret.data = response.data
            } catch (error: any) {
                console.error("🚀 ~ speechToText ~ error:", error)
                ret.error = error
            }

            return ret
        },

        /**將cmn-hant-tw字串替換 */
        transferZhTwLang(lang: string) {
            const sLang = speechLanguageList.find(sLang => sLang.id === 4) // 鎖定為'中文'
            return lang.toLowerCase() === sLang?.value.toLowerCase() ? 'zh-TW' : lang
        },
    }
})